import { useSelector } from "react-redux";

const useShowSteps = caseId => {
  const { toggledCaseId } = useSelector(state => state.cases);
  return toggledCaseId && caseId === toggledCaseId;
};

export default useShowSteps;
